module.exports = __webpack_public_path__ + "static/media/samsung-aife-2020-camera.e5fb938d.mp4";